(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ao-shipping-estimator"] && !Shopify.designMode) return;
  try {
    (async () => {
  const { StandardEvents } = await import('@shopify/events');

  class AOShippingEstimator extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.querySelector('form');
      this.country = this.querySelector('[name="country"]');
      this.province = this.querySelector('[name="province"]');
      this.result = this.querySelector('[role="status"]');
      this.button = this.querySelector('button');
      this.generation = 0;
      const initial = [...this.country.options].find(option => option.value === this.dataset.country || option.textContent.trim() === this.dataset.country);
      if (initial) this.country.value = initial.value;
      this.setProvinces();
      this.onCountry = () => { this.setProvinces(); this.invalidate(); };
      this.onInput = () => this.invalidate();
      this.onSubmit = event => { event.preventDefault(); this.calculate(); };
      this.onCart = () => this.invalidate(true);
      this.country.addEventListener('change', this.onCountry);
      this.form.addEventListener('input', this.onInput);
      this.form.addEventListener('submit', this.onSubmit);
      document.addEventListener(StandardEvents.cartLinesUpdate, this.onCart);
      document.addEventListener(StandardEvents.cartDiscountUpdate, this.onCart);
      document.addEventListener('quantity-selector:update', this.onCart);
    }

    disconnectedCallback() {
      this.invalidate();
      this.country?.removeEventListener('change', this.onCountry);
      this.form?.removeEventListener('input', this.onInput);
      this.form?.removeEventListener('submit', this.onSubmit);
      document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCart);
      document.removeEventListener(StandardEvents.cartDiscountUpdate, this.onCart);
      document.removeEventListener('quantity-selector:update', this.onCart);
      this.bound = false;
    }

    setProvinces() {
      const values = JSON.parse(this.country.selectedOptions[0]?.dataset.provinces || '[]');
      this.province.replaceChildren(new Option(this.dataset.select, ''));
      for (const [value, label] of values) this.province.add(new Option(label, value));
      this.province.required = values.length > 0;
      this.province.disabled = values.length === 0;
      this.querySelector('[data-province-label]').hidden = values.length === 0;
    }

    invalidate(cartChanged = false) {
      this.generation = (this.generation || 0) + 1;
      this.controller?.abort();
      if (this.result) this.result.textContent = cartChanged ? this.dataset.changed : '';
      if (this.button) this.button.disabled = false;
      this.removeAttribute('aria-busy');
    }

    signature(cart) {
      return JSON.stringify([cart.currency, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
    }

    async calculate() {
      if (this.button.disabled || !this.form.reportValidity()) return;
      if (this.country.value === '---') { this.result.textContent = this.dataset.error; return; }
      this.invalidate();
      const generation = this.generation;
      this.controller = new AbortController();
      const controller = this.controller;
      const signal = controller.signal;
      const timer = setTimeout(() => controller.abort(), 20000);
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.result.textContent = this.dataset.loading;
      const request = async (url, method = 'GET') => {
        const response = await fetch(url, { method, signal, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Shipping unavailable');
        return response.json();
      };
      try {
        const before = await request(this.dataset.cartUrl + '.js');
        // Blocks shipping profile: Mexico is intentionally excluded by the merchant.
        const internationalOnlyProducts = new Set([9029223022841, 9029225742585, 9029304647929, 9029306220793, 9029312774393, 9029316903161]);
        if (this.country.value === 'Mexico' && before.items.some(item => internationalOnlyProducts.has(item.product_id))) {
          this.result.textContent = this.dataset.mexico;
          return;
        }
        if (!before.item_count) throw new Error('Empty cart');
        const params = new URLSearchParams({
          'shipping_address[country]': this.country.value,
          'shipping_address[province]': this.province.disabled ? '' : this.province.value,
          'shipping_address[zip]': this.form.elements.zip.value.trim()
        });
        const base = this.dataset.cartUrl;
        await request(base + '/prepare_shipping_rates.json?' + params, 'POST');
        let data = null;
        for (let attempt = 0; attempt < 12; attempt++) {
          data = await request(base + '/async_shipping_rates.json?' + params);
          if (data !== null) break;
          await new Promise(resolve => setTimeout(resolve, 700));
          if (signal.aborted) throw new Error('Aborted');
        }
        if (!data || !Array.isArray(data.shipping_rates)) throw new Error('No result');
        const after = await request(base + '.js');
        if (generation !== this.generation || !this.isConnected) return;
        if (this.signature(before) !== this.signature(after)) { this.invalidate(true); return; }
        this.result.replaceChildren();
        if (!data.shipping_rates.length) { this.result.textContent = this.dataset.empty; return; }
        const heading = document.createElement('p');
        heading.textContent = this.dataset.results;
        const list = document.createElement('ul');
        for (const rate of data.shipping_rates) {
          const price = Number(rate.price);
          if (!Number.isFinite(price)) throw new Error('Invalid price');
          const row = document.createElement('li');
          const name = document.createElement('span');
          name.textContent = rate.presentment_name || rate.name;
          const amount = document.createElement('strong');
          amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: rate.currency || after.currency || this.dataset.currency, currencyDisplay: 'code' }).format(price);
          row.append(name, amount);
          list.append(row);
        }
        this.result.append(heading, list);
      } catch {
        if (generation === this.generation && this.isConnected) this.result.textContent = this.dataset.error;
      } finally {
        clearTimeout(timer);
        if (generation === this.generation) { this.button.disabled = false; this.removeAttribute('aria-busy'); }
      }
    }
  }
  if (!customElements.get('ao-shipping-estimator')) customElements.define('ao-shipping-estimator', AOShippingEstimator);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    class AOCartCheckoutActions extends HTMLElement {
    static observedAttributes = ['data-cart-products'];
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === null || oldValue === newValue || !this.isConnected) return;
      const cart = this.closest('cart-items-component');
      if (cart && !cart.hasAttribute('data-drawer')) window.location.reload();
    }
  }
  if (!customElements.get('ao-cart-checkout-actions')) {
    customElements.define('ao-cart-checkout-actions', AOCartCheckoutActions);
  }
  } catch(e) { console.error(e); }
})();

})();
